module.exports = __webpack_public_path__ + "static/img/anasayfa1.b2ad50d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anasayfa1.jpg
// module id = rWoR
// module chunks = 1